import { useEffect, useRef } from "react";
import Navigation from "@/components/Navigation";
import Hero from "@/components/Hero";
import HeroBottom from "@/components/HeroBottom";
import Services from "@/components/Services";
import HeroThird from "@/components/HeroThird";
import SocialProof from "@/components/SocialProof";
import HomePageSEOContent from "@/components/HomePageSEOContent";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import SEOHead from "@/components/SEOHead";

const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      <SEOHead
        title="St. George Utah Homes for Sale | Neil Gibbs"
        description="Find homes for sale in St. George, Utah. Expert real estate agent Neil Gibbs helps buyers and sellers in Washington County, Southern Utah. Browse listings today."
        path="/"
      />
      <Navigation />
      <Hero />
      <HeroBottom />
      <Services />
      <HeroThird />
      <SocialProof />
      <HomePageSEOContent />
      <Contact />
      <Footer />
    </div>
  );
};

export default Index;
